import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { throwError, catchError } from 'rxjs';

const allowedUnauthedRoutes = ['guest', 'recruiting', 'version-info', 'nickname', 'activate-mfa', 'verify-mfa'];

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const redirectBackUrl = this.router.routerState.snapshot.url;
        const authRequired = !allowedUnauthedRoutes.some((route) => redirectBackUrl.includes(route));

        if (redirectBackUrl !== '' && authRequired) {
          if (
            (error.status === 403 && error?.error?.errors[0]?.message?.includes('Not authorized.')) ||
            (error.status === 401 && error?.error?.detail === 'Authentication credentials were not provided.')
          ) {
            this.router.navigate(['/logout'], { queryParams: { next: redirectBackUrl } });
          }
        }
        return throwError(() => error);
      })
    );
  }
}
